import { Badge, Form, Space, Tabs, Typography } from 'antd';
import type { NamePath } from 'antd/es/form/interface';
import { CAMPOS_DE_COMENTARIO, COMENTARIO_LABEL } from '../dominio';
import { EditorTexto } from './EditorTexto';

/**
 * O Comentário: legislação, jurisprudência e doutrina.
 *
 * O escopo diz que é o principal valor da plataforma e que a questão pode ter
 * um, dois ou os três campos - campo sem conteúdo não aparece para o aluno. A
 * marca ao lado do nome da aba existe para o administrador ver de relance o que
 * já escreveu sem abrir cada uma.
 */
export function ComentarioResolucao({ name }: { name: NamePath }) {
  const base = Array.isArray(name) ? name : [name];

  return (
    <Tabs
      size="small"
      items={CAMPOS_DE_COMENTARIO.map((campo) => ({
        key: campo,
        label: (
          <Space size={6}>
            {COMENTARIO_LABEL[campo]}
            {/*
              A marca acompanha o campo sem redesenhar o editor: só ela assina
              a mudança, então digitar não recria a área de escrita.
            */}
            <Form.Item noStyle shouldUpdate>
              {(instancia) =>
                instancia.getFieldValue([...base, campo]) ? <Badge status="success" /> : null
              }
            </Form.Item>
          </Space>
        ),
        children: (
          <Space orientation="vertical" size={4} style={{ width: '100%' }}>
            <Form.Item name={[...base, campo]} noStyle>
              <EditorTexto minHeight={160} placeholder={COMENTARIO_LABEL[campo]} />
            </Form.Item>
            <Typography.Text type="secondary">
              Em branco, este campo não aparece para o aluno.
            </Typography.Text>
          </Space>
        ),
      }))}
    />
  );
}
